// extracted by mini-css-extract-plugin
module.exports = {"list":"QuoteList_list__3GpEf","sorting":"QuoteList_sorting__2HMH7"};